<template>
  <div class="calendar-select__wrapper">
    <div class="input-group date-picker" @mouseover="setHover(true)" @mouseout="setHover(false)">
      <div class="el-date-editor el-input el-input--prefix el-input--suffix el-date-editor--date">
        <input
          :name="name"
          v-model="selectedDate"
          @input="onInput"
          @change="onChange"
          :disabled="readOnly"
          type="text"
          autocomplete="off"
          class="el-input__inner"
          @click="onClick"
        />
        <span class="el-input__prefix">
          <i class="el-input__icon el-icon-date"></i>
        </span>
        <span class="el-input__suffix">
          <span class="el-input__suffix-inner">
            <i class="el-input__icon" :class="{ 'el-icon-circle-close': showCloseBtn }" @click="clear"></i>
          </span>
        </span>
      </div>
    </div>
    <el-drawer
      size="100%"
      direction="rtl"
      append-to-body
      :before-close="handleClose"
      :visible.sync="showCalendar"
      data-id="calendar_select_modal"
    >
      <template slot="title" class="new-modal-header">
        <h4 class="modal-title">{{ $i18n.t('calendar_select') }}</h4>
        <el-button v-show="showSaveBtn" type="primary" @click="onSave" data-id="calendar_save_btn">{{
          $i18n.t('calendar_select_save')
        }}</el-button>
      </template>
      <div class="new-modal-content p-2">
        <full-calendar-wrapper
          v-if="showCalendar"
          :calendar-options="calendarOptions"
          :entity-collection="entityCollection"
          :date-format="dateFormat"
          :date-time-format="dateTimeFormat"
          :is-form-field="true"
          :field-type="type"
          :selected-date="selectedDate"
          :min-date="minDate"
          :max-date="maxDate"
          :field-id="name"
          @date-selected="onDateSelected"
        ></full-calendar-wrapper>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { get, isNaN } from 'lodash'
import confirmation from '../../../utils/mixin-confirmation'
import FullCalendarWrapper from '../../fullcalendar/FullCalendarWrapper'

export default {
  name: 'CalendarSelect',
  components: { FullCalendarWrapper },
  mixins: [confirmation],
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    dateValue: {
      type: String,
      default: '',
    },
    minDate: {
      type: String,
      default: '',
    },
    maxDate: {
      type: String,
      default: '',
    },
    calendarProperties: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hover: false,
      selectedDate: '',
      showCalendar: false,
    }
  },
  methods: {
    onClick() {
      if (this.readOnly) return
      this.showCalendar = true
    },
    onDateSelected(date) {
      this.selectedDate = date
      if (!this.showSaveBtn) {
        this.onSave()
      }
    },
    isValidDate(dateStr) {
      const date = new Date(dateStr)
      return date && !isNaN(date.getTime())
    },
    onInput() {
      if (this.isValidDate(this.selectedDate)) {
        this.setDateSelected(this.selectedDate)
      }
    },
    onChange() {
      if (!this.isValidDate(this.selectedDate)) {
        this.selectedDate = ''
      }
    },
    clear() {
      this.selectedDate = ''
      this.setDateSelected(this.selectedDate)
    },
    closeModal() {
      this.showCalendar = false
    },
    onSave() {
      this.setDateSelected(this.selectedDate)
      this.closeModal()
    },
    setDateSelected(date) {
      this.$emit('date-selected', date)
    },
    setHover(value) {
      this.hover = value
    },
    async handleClose() {
      let confirmed = true
      if (this.showSaveBtn) {
        confirmed = await this._confirm('confirm_close_calendar_select')
      }

      if (confirmed) {
        this.closeModal()
      }
    },
  },
  mounted() {
    this.selectedDate = this.isValidDate(this.dateValue) ? this.dateValue : ''
  },
  computed: {
    showCloseBtn() {
      return this.hover && this.selectedDate && !this.readOnly
    },
    showSaveBtn() {
      return get(this.calendarProperties, 'showSaveButton', false)
    },
    calendarOptions() {
      return get(this.calendarProperties, 'calendarOptions', {})
    },
    entityCollection() {
      return get(this.calendarProperties, 'entityCollection', [])
    },
    dateFormat() {
      return get(this.calendarProperties, 'dateFormat', 'YYYY-MM-DD')
    },
    dateTimeFormat() {
      return get(this.calendarProperties, 'dateTimeFormat', 'YYYY-MM-DD HH:mm:ss')
    },
  },
  watch: {
    dateValue: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selectedDate = this.isValidDate(newValue) ? newValue : ''
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.calendar-select__wrapper {
  width: 100%;
}
.el-input__suffix {
  width: 25px;
  height: 100%;
}

[disabled] {
  background: $background-color-readonly !important;
  cursor: not-allowed !important;
}
</style>
